export const newDocumentData = () => {
  return {
    fDocumentId: -1,
    fDocumentEmpId: '',
    fDocumentOwnerId: '',
    fDocumentOwnerType: '',
    fDocumentName: '',
    fDocumentDocType: '',
    fDocumentDocReadOnly: '',
    fDocumentDescription: '',
    fEquipmentAttachment: '',
    fDocumentSha1Hash: '',
    fDocumentApprovalStatus: '',
    fDocumentCreated: '',
    fDocumentModified: '',
    fDocumentExpirationDate: '',
    fDocumentAttachment: undefined,
  };
};
